module.exports = __webpack_public_path__ + "img/elementos-esquerda.cfb5b531.svg";